import CheckboxSelect from "./CheckboxSelect";

export default CheckboxSelect;